export const SurveyQuestion_FreeText = 'free-text';
export const SurveyQuestion_Scale = 'scale';
//# sourceMappingURL=types.js.map